/**
 * Hand-off from other pages (e.g. Content Studio "Ideas & requests") to the Draper chat box.
 * The sender stores the text, navigates to /draper, and Draper reads + clears it on mount.
 */
export const DRAPER_PREFILL_KEY = "drpr-draper-prefill";

export function setDraperPrefill(text: string): void {
  try {
    sessionStorage.setItem(DRAPER_PREFILL_KEY, text);
  } catch {
    /* storage blocked: the user just lands on an empty chat box */
  }
}

/** Returns the pending prefill text (if any) and clears it so it is only used once. */
export function takeDraperPrefill(): string | null {
  try {
    const text = sessionStorage.getItem(DRAPER_PREFILL_KEY);
    if (text) sessionStorage.removeItem(DRAPER_PREFILL_KEY);
    return text && text.trim() ? text : null;
  } catch {
    return null;
  }
}
